export const addItemToCart = (cartItems, cartItemToAdd, participationAmount) => {

    const existingCartItem = cartItems.find(
        cartItem => cartItem.reference === cartItemToAdd.reference
    );

    if (existingCartItem) {
        return cartItems.map(cartItem =>
            cartItem.reference === cartItemToAdd.reference
                ? {...cartItem, amount: participationAmount}
                : cartItem
        );
    }

    return [...cartItems, {...cartItemToAdd, amount: participationAmount}];
};

